import axios from "axios";

import { config } from "@krea/shared/config";

import type {
  IFIAuthenticateRequest,
  IFIAuthenticateResponse,
  IFIFinalizeRequest,
  IFIFinalizeResponse,
  IFIInitializeResponse,
} from "./types";

// Create axios instance without interceptors to avoid circular dependencies
const bankIDApiClient = axios.create({
  baseURL: config.apiRootUrl,
});

/**
 * Initialize FI BankID - fetches list of available banks
 */
export const initializeFI = async () => {
  return await bankIDApiClient.post<IFIInitializeResponse>(
    "/api/fi/v1/identity/initialize",
  );
};

/**
 * Start authentication with selected bank
 * Returns the OAuth URL to redirect the user to
 */
export const authenticateViaFI = async (params: IFIAuthenticateRequest) => {
  return await bankIDApiClient.post<IFIAuthenticateResponse>(
    "/api/fi/v1/identity/authenticate",
    params,
  );
};

/**
 * Finalize authentication after OAuth callback
 * Exchanges the code for access and refresh tokens
 */
export const finalizeFI = async (params: IFIFinalizeRequest) => {
  return await bankIDApiClient.post<IFIFinalizeResponse>(
    "/api/fi/v1/identity/finalize",
    params,
    {
      // See the equivalent note in ../SE/api.ts: ADMIN_WEB answers with a Django
      // session cookie, which the browser only keeps on a credentialed request.
      withCredentials: params.authentication_context === "ADMIN_WEB",
    },
  );
};
